/**
 * Dashboard API Service
 * - Fetches admin dashboard statistics
 * - Retrieves metrics, charts data, and recent activity
 */

import apiClient from "./apiClient";

// Fetch dashboard statistics and data
export const fetchDashboardAPI = async () => {
  const response = await apiClient.get(`/tailmission/api/v1/admin/dashboard`);
  return response;
};

export default fetchDashboardAPI;
